/* BulkActionBar — Iter 110/Faz2+Faz4: sticky bottom toplu aksiyon barı. */
import React from 'react';
import { Loader2, Printer, FileCheck, X } from 'lucide-react';

export default function BulkActionBar({
    count, onClear,
    onPrint, onPickSlip, onPush,
    busyPrint, busyPush,
}) {
    if (count <= 0) return null;
    return (
        <div
            className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-gray-900 text-white rounded-2xl shadow-2xl px-4 py-3 flex items-center gap-3"
            data-testid="bulk-action-bar">
            <div className="flex items-center gap-2 pr-2 border-r border-gray-700">
                <span className="text-sm font-bold">{count}</span>
                <span className="text-xs text-gray-300">sipariş seçili</span>
                <button
                    onClick={onClear}
                    className="ml-1 h-6 w-6 rounded-md hover:bg-gray-700 flex items-center justify-center"
                    title="Seçimi temizle"
                    data-testid="bulk-clear">
                    <X size={12} />
                </button>
            </div>
            <button
                onClick={onPrint}
                disabled={busyPush || busyPrint}
                className="h-8 px-3 text-xs font-semibold bg-cyan-600 hover:bg-cyan-700 disabled:opacity-50 rounded-md flex items-center gap-1.5"
                data-testid="bulk-print-labels-btn">
                {busyPrint ? <Loader2 size={12} className="animate-spin" /> : <Printer size={12} />}
                Etiket Bas
            </button>
            <button
                onClick={onPickSlip}
                disabled={busyPush || busyPrint}
                className="h-8 px-3 text-xs font-semibold bg-gray-700 hover:bg-gray-600 disabled:opacity-50 rounded-md flex items-center gap-1.5"
                data-testid="bulk-pick-slip-btn"
                title="Bol API kullanmadan sadece pick slip">
                <Printer size={12} />
                Pick Slip
            </button>
            <button
                onClick={onPush}
                disabled={busyPush}
                className="h-8 px-3 text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 rounded-md flex items-center gap-1.5"
                data-testid="bulk-push-btn">
                {busyPush ? <Loader2 size={12} className="animate-spin" /> : <FileCheck size={12} />}
                Billit&apos;e Aktar
            </button>
        </div>
    );
}
